import { Button, Popconfirm } from "antd";
import { useTranslation } from "react-i18next";
import type { TooltipPlacement } from "antd/es/tooltip";
import { BaseButtonProps } from "antd/lib/button/button";

const ComfirmButton = ({
  popTitle,
  description,
  onClick,
  title,
  placement,
  buttonCogfig,
}: {
  title?: string;
  popTitle?: string;
  onClick: () => void;
  description?: string;
  buttonCogfig?: BaseButtonProps;
  placement?: TooltipPlacement;
}) => {
  const { t } = useTranslation();
  return (
    <Popconfirm
      placement={placement || "topRight"}
      title={popTitle || t("hint.deleteTitle", { name: "Delete" })}
      description={description || t("hint.deleteTask", { name: "Delete" })}
      okText={t("yes")}
      cancelText={t("cancel")}
      onConfirm={onClick}
    >
      <Button variant="outlined" {...buttonCogfig} color="primary">
        {title}
      </Button>
    </Popconfirm>
  );
};

export default ComfirmButton;
